import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useQuery } from '@tanstack/react-query'
import { GetTotalSaleInput } from '../../domain/dtos/get-total-sale-input'
import { Indicator } from '../../domain/dtos/indicator'
import { QueryKey } from '../../domain/dtos/query-keys'
import { Status } from '../../domain/dtos/status'
import { GetTotalSale } from '../../usecases/get-total-sale'

export const useGetTotalSale = (input: GetTotalSaleInput, isLoading: boolean) => {
  const container = useContainer()

  const offerIds = input.offers.filter(({ id }) => id !== 'all').map(({ id }) => id)

  const enabled = !isLoading && offerIds.length > 0

  const initialData = {
    current: 0,
    previous: 0,
    percentage: '0%',
    status: Status.neutral,
    indicator: Indicator.down,
  }

  return useQuery(
    [
      QueryKey.getTotalSale,
      JSON.stringify({
        startDate: input.startDate,
        endDate: input.endDate,
        offerIds: input.offerIds,
      }),
    ],
    ({ signal }) => {
      if (!enabled) {
        return Promise.resolve(initialData)
      }
      return new GetTotalSale(container.get(HttpClient)).execute(input, signal)
    },
    {
      retry: 3,
      retryOnMount: false,
      refetchOnWindowFocus: false,
      initialData,
      enabled,
    },
  )
}
